export default "__VITE_ASSET__BmXOGbO6__"